import mitt from 'mitt'

export const CREATE_FOCUS_EVENT_NAME: string = 'createFocus'

export type CreateFocusEvent = {
  from: number
  to: number
}

export const emitter = mitt()
